/* eslint-disable @typescript-eslint/no-explicit-any */
const LOG_LEVELS = {
    debug: 0,
    info: 1,
    warn: 2,
    error: 3,
    none: 4
} as const;

type LogLevel = keyof typeof LOG_LEVELS;

const level = (process.env.VUE_APP_LOG_LEVEL || 'error') as LogLevel;
const currentLevel = LOG_LEVELS[level] ?? 0;

export const logger = {
    debug: (...args: any[]) => {
        if (currentLevel <= LOG_LEVELS.debug) console.log(...args);
    },
    info: (...args: any[]) => {
        if (currentLevel <= LOG_LEVELS.info) console.info(...args);
    },
    warn: (...args: any[]) => {
        if (currentLevel <= LOG_LEVELS.warn) console.warn(...args);
    },
    error: (...args: any[]) => {
        if (currentLevel <= LOG_LEVELS.error) console.error(...args);
    }
};